import { render } from "./SetBureauTime.vue?vue&type=template&id=bcaae276&scoped=true"
import script from "./SetBureauTime.vue?vue&type=script&lang=js"
export * from "./SetBureauTime.vue?vue&type=script&lang=js"

import "./SetBureauTime.vue?vue&type=style&index=0&id=bcaae276&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcaae276"]])

export default __exports__